import { axiosInstance } from "../../../api/axiosInstance";
import { appCache } from "../../../cache/appCache";
import { Section } from "../types";

// Cached (appCache bucket "sections")
export const fetchSections = (): Promise<Section[]> =>
  appCache.getOrFetch("sections", () => axiosInstance.get<Section[]>("/sections").then((response) => response.data));

export const createSection = async (section: Pick<Section, "code" | "name" | "description">): Promise<Section> => {
  const response = await axiosInstance.post<Section>("/sections", section);
  // Grades carry their sections, so both buckets go stale
  appCache.invalidate("sections");
  appCache.invalidate("grades");
  return response.data;
};
